import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormCheck,
} from "@coreui/react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import {
  createUser,
  getSingleUser,
  updateUser,
} from "../../services/user.services";
import {
  getAllUserTypeList,
  getAllActiveUserTypeList,
} from "src/services/user-type.services";
import {
  getSearchableStoreList,
  getStoreList,
} from "../../services/store.services";
import { uploadImage } from "src/services/util.services";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { getActiveCountryList } from "src/services/country.services";
import moment from "moment";
import ReactSelect from "react-select";

const drivingLicenseTypeOptions = [
  {
    label: "Learner License",
    value: "learner-license",
  },
  {
    label: "Professional License",
    value: "professional-license",
  },
  {
    label: "Non-Professional License",
    value: "non-professional-license",
  },
  {
    label: "Public Service Vehicle License",
    value: "public-service-vehicle-license",
  },
  // {
  //   label: "Public Service Vehicle License",
  //   value: "public-service-vehicle-license",
  // },
  {
    label: "Instructor License",
    value: "instructor-license",
  },
];

const driverTypeOptions = [
  {
    label: "Delivery (commerce)",
    value: "delivery-commerce",
  },
  {
    label: "Taxicab Driver",
    value: "taxicab-driver",
  },
  {
    label: "Truck Driver",
    value: "truck-driver",
  },
];

const CreateUserForm = () => {
  const userInfo = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const [userId, setUserId] = useState("");
  const [userData, setUserData] = useState(null);
  const [countryData, setCountryData] = useState([]);
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [allUserTypeData, setAllUserTypeData] = useState(null);
  const [userTypeData, setUserTypeData] = useState([]);
  const [userImage, setUserImage] = useState(null);
  const { id } = useParams();
  const [selecteduserType, setSelecteduserType] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedStoreOption, setSelectedStoreOption] = useState(null);
  const [storeOptions, setStoreOptions] = useState([]);
  const [webPasswordLogin, setWebPasswordLogin] = useState(false);

  //store userType value = 64a64b36a2ef02fb5725b215

  // useEffect(() => {
  //   console.log(selecteduserType)
  // },[selecteduserType])
  const schema = z.object({
    userType: z.string().nonempty("Please select user type"),
    designation: z.string().min(1, "Please type designation"),
    avatar: z.string().optional(),
    country: z.string().min(1, "Please select a country"),
    location: z.string().optional(),
    // vehicleId: z.string().optional(),
    TagId: z.string().optional(),
    tagId: z.string().optional(),
    firstName: z.string().nullish(),
    lastName: z.string().min(1, "Field is required"),
    employeeCode: z.string().min(1, "Please type employee code"),
    email: z
      .string()
      .min(1, "Please type email")
      .email("This is not a valid email."),
    password: z.string().superRefine((value, ctx) => {
      // const { userType } = ctx.form.$data;
      if (selecteduserType === "driver" && !userId && value.length <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Password is required",
          path: ["password"],
          fatal: true,
        });
      }
    }),
    // Initially commented for future usage
    // driverDetails:
    //   selecteduserType === "driver"
    //     ? z.object({
    //         driverId: z.string().min(1, { message: "Driver ID required" }),
    //         dollasId: z.string().min(1, { message: "Dollas ID required" }),
    //         mobileNumber: z
    //           .string()
    //           .min(1, { message: "Mobile number required" }),
    //         dateOfBirth: z
    //           .string()
    //           .min(1, { message: "Date of birth required" }),
    //         dateOfJoin: z.string().min(1, { message: "Date of join required" }),
    //         nationality: z.string().min(1, { message: "Nationality required" }),
    //         region: z.string().min(1, { message: "Region required" }),
    //         driverType: z.object(
    //           {
    //             label: z.string(),
    //             value: z.string(),
    //           },
    //           {
    //             required_error: "Driver type required",
    //             invalid_type_error: "Driver type required",
    //           }
    //         ),
    //         licenseNumber: z.string().min(1, { message: "Lincense required" }),
    //         licenseCity: z
    //           .string()
    //           .min(1, { message: "License city required" }),
    //         licenseIssuedDate: z
    //           .string()
    //           .min(1, { message: "License issue date is required" }),
    //         licenseExpiredDate: z.string().min(1, { message: "required" }),
    //         drivingLicenseType: z.object(
    //           {
    //             label: z.string(),
    //             value: z.string(),
    //           },
    //           {
    //             required_error: "Driving license type is required",
    //             invalid_type_error: "Driving license type is required",
    //           }
    //         ),
    //         passportNumber: z
    //           .string()
    //           .min(1, { message: "Passport number is required" }),
    //         passportIssueDate: z
    //           .string()
    //           .min(1, { message: "Driver ID required" }),
    //         passportExpireDate: z
    //           .string()
    //           .min(1, { message: "Driver ID required" }),
    //         visaNumber: z.string().min(1, { message: "Driver ID required" }),
    //         visaCity: z.string().min(1, { message: "Driver ID required" }),
    //         visaIssueDate: z.string().min(1, { message: "Driver ID required" }),
    //         visaExpiredDate: z
    //           .string()
    //           .min(1, { message: "Driver ID required" }),
    //       })
    //     : z.undefined(),
  });

  const {
    control,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      userType: "",
      designation: "",
      email: "",
      firstName: "",
      lastName: "",
      employeeCode: "",
      avatar: "",
      tagId: "",
      location: "",
      country: selectedCountry ? selectedCountry.value : "",
      driverDetails: {
        driverId: "",
        dollasId: "",
        mobileNumber: "",
        dateOfBirth: "",
        dateOfJoin: "",
        nationality: "",
        region: "",
        driverType: "",
        licenseNumber: "",
        licenseCity: "",
        licenseIssuedDate: "",
        licenseExpiredDate: "",
        drivingLicenseType: "",
        passportNumber: "",
        passportIssueDate: "",
        passportExpireDate: "",
        visaNumber: "",
        visaCity: "",
        visaIssueDate: "",
        visaExpiredDate: "",
      },
    },
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (userInfo?.country) {
      setSelectedCountry({
        value: userInfo.country._id,
        label: `${userInfo.country.name}-${userInfo.country.code}`,
      });
      setValue("country", userInfo.country._id);
      getStoreInfo(userInfo.country._id);
    }
    if (userInfo?.userType === "superAdmin") {
      getCountryList();
    }
    getUserTypeInfo();
    // getStoreInfo();
  }, []);

  useEffect(() => {
    if (id) {
      setUserId(id);
      getUserInfo(id);
    }
    console.log("id======", id);
  }, [id]);

  const defaultPassword = "";

  const getCountryList = () => {
    let params = {
      limit: 20,
      page: 1,
      status: true,
    };
    getActiveCountryList(params)
      .then((response) => {
        if (response.success && response.data) {
          let countries = response.data;
          setCountryData(countries);
          let options = countries.map((item) => ({
            value: item._id,
            label: `${item.name}-${item.code}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  const getUserInfo = (id) => {
    
    getSingleUser(id)
      .then(async (response) => {
        console.log("response", response);
        setUpdatedUserData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getUserTypeInfo = () => {
    getAllActiveUserTypeList()
      .then(async (response) => {
        const userType = response.data;
        setAllUserTypeData(userType);
        let options = userType.map((element) => ({
          label: element.name + " - " + element.type,
          value: element._id,
        }));
        setUserTypeData(options);
      })
      .catch((error) => {
        console.error(error?.response?.data);
      });
  };

  const getStoreInfo = (country, search = "") => {
    getStoreList({ limit: 100, page: 1, country, q: search })
      .then((response) => {
        if (response.success && response.data) {
          const storeData = response.data;
          let options = storeData.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
            locationCode: `${element.locationCode}`,
          }));
          setStoreOptions(options);
        }
      })
      .catch((error) => console.log(error?.response?.data));
  };

  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );

  const onSubmit = (data) => {
    if (selectedCountry) data.country = selectedCountry.value;

    // Add webPasswordLogin to form data
    data.webPasswordLogin = webPasswordLogin;

    if (userId) {
      if (data.password === defaultPassword) {
        data.password = "";
      }
      toast
        .promise(
          updateUser(data, userId),
          {
            loading: "Loading",
            success: "User Updated Successfully",
            error: (err) => {
              return err.response?.data?.message || defaultErrorMessage;
            },
          },
          {
            id: "updateuser",
          }
        )
        .then((response) => {
          setUpdatedUserData(response.data);
        })
        .catch((error) => console.error(error));
    } else {
      toast
        .promise(
          createUser(data),
          {
            loading: "Loading",
            success: "User Created Succesfully",
            error: (err) => {
              return err.response &&
                err.response.data &&
                err.response.data.message
                ? err.response.data.message
                : defaultErrorMessage;
            },
          },
          {
            id: "createuser",
          }
        )
        .then(async (response) => {
          reset();
          if (userInfo && userInfo?.country) {
            setSelectedCountry({
              value: userInfo.country._id,
              label: `${userInfo.country.name}-${userInfo.country.code}`,
            });
            setValue("country", userInfo.country._id);
          }
          setUserImage(null);
          setSelectedStoreOption("");
          setSelecteduserType("");
          setSelectedUser("");
        })
        .catch((error) => console.error(error));
    }
  };

  const onError = (err) => {
    console.error(err);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    toast
      .promise(
        uploadImage(formData, config),
        {
          loading: "Loading",
          success: "Image added Succesfully",
          error: (err) => {
            console.log(err);
            return "Something went wrong. Please upload again";
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        console.log("response", response);
        setValue("avatar", response.url);
        setUserImage(response.url);
      })
      .catch((error) => console.error(error));
  };

  const handleUserOnChange = (selectedOption) => {
    setValue("driverDetails", undefined);
    if (selectedOption) {
      console.log(selectedOption);
      // if (selectedOption.value === "64a64b36a2ef02fb5725b215")
      //   setIsStoreUser(true);
      setValue("userType", selectedOption.value);
      const filter = allUserTypeData.filter(
        (d) => d._id === selectedOption.value
      );
      setSelecteduserType(filter.length > 0 ? filter[0].type : "");
      setSelectedUser(selectedOption);
    } else {
      setValue("userType", "");
      setSelecteduserType("");
      setSelectedUser(null);
    }
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountry(selectedOption);
      console.log(selectedOption);
      setValue("country", selectedOption.value);

      if (
        !["superAdmin", "admin", "cvit", "driver"].includes(
          selecteduserType.trim().toString()
        )
      ) {
        setSelectedStoreOption("");
        setValue("location", "");
        setValue("lastName", "");
        getStoreInfo(selectedOption?.value);
      }
    } else {
      setSelectedCountry("");
      setSelectedStoreOption("");
      setStoreOptions([]);
      setValue("country", "");
    }
  };

  const handleChangeStore = (selectedOption) => {
    if (selectedOption) {
      setSelectedStoreOption(selectedOption);
      setValue("location", selectedOption.value);
      if (selecteduserType === "store") {
        setValue("lastName", selectedOption?.locationCode);
        clearErrors("lastName");
      } else {
        setValue("lastName", "");
      }
      // if(selecteduserType)
    } else {
      setSelectedStoreOption("");
      setValue("location", "");
      if (userInfo.userType === "superAdmin") {
        getStoreInfo(selectedCountry?.value);
      } else {
        getStoreInfo(userInfo?.country?._id);
      }
    }
  };

  const handleStoreInputChange = (search) => {
    if (search) {
      let filtered = storeOptions.filter((item) => item.label.includes(search));
      if (filtered.length == 0) {
        getStoreInfo(userInfo?.country?._id, search);
      }
    }
  };

  const setUpdatedUserData = (data) => {
    setUserData(data);
    const {
      userType,
      designation,
      email,
      firstName,
      lastName,
      employeeCode,
      avatar,
      // vehicleId,
      tagId,
      location,
      country,
      driverDetails,
    } = data;
    setValue("userType", userType._id);
    setValue("designation", designation ? designation : "");
    setValue("email", email);
    setValue("firstName", firstName);
    setValue("lastName", lastName);
    setValue("employeeCode", employeeCode);
    setValue("avatar", avatar ? avatar : "");
    setValue("password", defaultPassword);
    // setValue("vehicleId", vehicleId ? vehicleId : "");
    setValue("tagId", tagId ? tagId : "");
    setValue("tagId", tagId ? tagId : "");
    setValue("location", location ? location._id : "");
    setUserImage(avatar);

    if (country?._id && country?.code && country?.name) {
      setSelectedCountry({ value: country._id, label: country.name });
      setValue("country", country._id);
    }

    const fetchedUserType = { label: userType.name, value: userType._id };

    setSelectedUser(fetchedUserType);
    setSelecteduserType(userType.type);

    if (location) {
      const fetchedUserLocationType = {
        label: location?.name,
        value: location?._id,
        locationCode: location?.locationCode,
      };
      setSelectedStoreOption(fetchedUserLocationType);
    }

    setWebPasswordLogin(data.webPasswordLogin ?? false);

    // Initially commented for future implementation
    // if (
    //   userType &&
    //   userType.type === "driver" &&
    //   driverDetails &&
    //   typeof driverDetails === "object" &&
    //   Object.keys(driverDetails).length > 0
    // ) {
    //   console.log("i am here");
    //   Object.keys(driverDetails).map((key, value) => {
    //     setValue(`driverDetails.${key}`, driverDetails[key]);
    //   });
    // }
  };

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CRow>
          <CCol sm={5}>
            <h4 id="traffic" className="card-title mb-0">
              {userId ? "Edit User" : "Create User"}
            </h4>
          </CCol>
          <CCol sm={7} className="d-none d-md-block"></CCol>
        </CRow>
        <hr />
        <br />
        <CForm onSubmit={handleSubmit(onSubmit, onError)}>
          <CRow>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="userType"
                  className="col-sm-3 col-form-label"
                >
                  User Type:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selectedUser}
                    onChange={handleUserOnChange}
                    options={userTypeData}
                    isClearable={true}
                    placeholder="Select User Type"
                    isDisabled={
                      !userTypeData && userTypeData?.length <= 0 ? true : false
                    }
                  />

                  {errors.userType?.message && (
                    <p className="error_text">{errors.userType?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="designation"
                  className="col-sm-3 col-form-label"
                >
                  Designation:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="designation"
                    {...register("designation")}
                  />
                  {errors.designation?.message && (
                    <p className="error_text">{errors.designation?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="employeeCode"
                  className="col-sm-3 col-form-label"
                >
                  Employee Code:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    maxLength={6}
                    id="employeeCode"
                    {...register("employeeCode")}
                  />
                  {errors.employeeCode?.message && (
                    <p className="error_text">{errors.employeeCode?.message}</p>
                  )}
                </CCol>
              </CRow>
              {/* {selecteduserType==='driver'? */}
              <CRow
                className={`mb-3 ${(selecteduserType === "driver" || webPasswordLogin) ? "" : "d-none"}`}
              >
                <CFormLabel
                  htmlFor="password"
                  className="col-sm-3 col-form-label"
                >
                  Password:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="password"
                    id="password"
                    {...register("password")}
                  />
                  {errors.password?.password.message && (
                    <p className="error_text">
                      {errors.password?.password.message}
                    </p>
                  )}
                </CCol>
              </CRow>
              {/* :''} */}
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="avatar"
                  className="col-sm-3 col-form-label"
                >
                  Image:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                  />

                  {errors.avatar?.message && (
                    <p className="error_text">{errors.avatar?.message}</p>
                  )}
                </CCol>
              </CRow>
            </CCol>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="country"
                  className="col-sm-3 col-form-label"
                >
                  Country:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selectedCountry}
                    options={countrySelectOptions}
                    onChange={handleCountryChange}
                    isClearable={true}
                    placeholder="Select Country"
                    isDisabled={
                      userInfo.userType === "superAdmin" ? false : true
                    }
                  />
                  {errors.country?.message && (
                    <p className="error_text">{errors.country?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow
                className={`mb-3 ${!["driver", "admin", "cvit"].find(
                  (v) => selecteduserType === v
                )
                  ? ""
                  : "d-none"
                  }`}
              >
                <CFormLabel
                  htmlFor="designation"
                  className="col-sm-3 col-form-label"
                >
                  Location:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selectedStoreOption}
                    onChange={handleChangeStore}
                    onInputChange={handleStoreInputChange}
                    options={storeOptions}
                    isClearable={true}
                    required={
                      !["driver", "admin", "cvit"].includes(selecteduserType)
                    }
                    isDisabled={selectedCountry ? false : true}
                  />
                  {errors.location?.message && (
                    <p className="error_text">{errors.location?.message}</p>
                  )}
                </CCol>
              </CRow>
              {selecteduserType !== "store" && (
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="firstName"
                    className="col-sm-3 col-form-label"
                  >
                    First Name:
                  </CFormLabel>
                  <CCol sm={8}>
                    <CFormInput
                      type="text"
                      id="firstName"
                      required={selecteduserType !== "store" ? true : false}
                      {...register("firstName")}
                    />
                    {errors.firstName?.message && (
                      <p className="error_text">{errors.firstName?.message}</p>
                    )}
                  </CCol>
                </CRow>
              )}

              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="lastName"
                  className="col-sm-3 col-form-label"
                >
                  {selecteduserType !== "store" ? "Last Name:" : "Store Code"}
                </CFormLabel>

                <CCol sm={8}>
                  {selecteduserType !== "store" ? (
                    <>
                      <CFormInput
                        type="text"
                        id="lastName"
                        {...register("lastName")}
                      />
                      {errors.lastName?.message && (
                        <p className="error_text">{errors.lastName?.message}</p>
                      )}
                    </>
                  ) : (
                    <>
                      <CFormInput
                        type="text"
                        value={
                          selectedStoreOption
                            ? selectedStoreOption.locationCode
                            : ""
                        }
                        readOnly={true}
                      />
                      {errors.lastName?.message && (
                        <p className="error_text">Location code is required</p>
                      )}
                    </>
                  )}
                </CCol>
              </CRow>

              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="designation"
                  className="col-sm-3 col-form-label"
                >
                  Email:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput type="email" id="email" {...register("email")} />
                  {errors.email?.message && (
                    <p className="error_text">{errors.email?.message}</p>
                  )}
                </CCol>
              </CRow>

              {selecteduserType !== "driver" && (
                <CRow
                className={`mb-3 ${selecteduserType === "driver" ? "" : "d-none"
                  }`}
              >
                <CFormLabel
                  // htmlFor="vehicleId"
                  htmlFor="Tag Id"
                  className="col-sm-3 col-form-label"
                >
                  Tag ID:
                  {/* Vehicle ID: */}
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="tagId"
                    // id="vehicleId"
                    {...register("tagId")}
                    // {...register("vehicleId")}
                  />
                  {errors.tagId?.message && (
                    <p className="error_text">{errors.tagId?.message}</p>
                  )}
                  {/* {errors.vehicleId?.message && (
                    <p className="error_text">{errors.vehicleId?.message}</p>
                  )} */}
                </CCol>
              </CRow>
              )}
             {selecteduserType=== "driver" && (
                <CRow
                className={`mb-3`}
              >
                <CFormLabel
                  // htmlFor="vehicleId"
                  htmlFor="tagId"
                  className="col-sm-3 col-form-label"
                >
                  Tag ID:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="tagId"
                    {...register("tagId")}
                  />
                  {errors.tagId?.message && (
                    <p className="error_text">{errors.tagId?.message}</p>
                  )}
                </CCol>
              </CRow>
             )}

              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="webPasswordLogin"
                  className="col-sm-3 col-form-label"
                >
                  Web Password Login:
                </CFormLabel>
                <CCol sm={8} className="d-flex align-items-center">
                  <div className="form-switch" style={{ position: 'relative' }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="webPasswordLogin"
                      checked={webPasswordLogin}
                      onChange={(e) => setWebPasswordLogin(e.target.checked)}
                      style={{ position: 'relative', zIndex: 2 }}
                    />
                  </div>
                </CCol>
              </CRow>

              {userImage ? (
                <CRow className="mb-3">
                  <CCol sm={12}>
                    <img src={userImage} height={110} />
                  </CCol>
                </CRow>
              ) : (
                ""
              )}
            </CCol>

            {/* Initially commented for future usage */}
            {/* {selecteduserType && selecteduserType === "driver" && (
              <>
                <div className="w-100 mb-3">
                  <h4>Driver Details</h4>
                  <hr />
                  <CRow xs={{ cols: 1, gutter: 4 }} md={{ cols: 4, gutter: 4 }}>
                    <CCol>
                      <CFormLabel>Driver Id</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.driverId")}
                      />
                      {errors.driverDetails?.driverId?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.driverId?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Dollas Id</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.dollasId")}
                      />
                      {errors.driverDetails?.dollasId?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.dollasId?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Mobile No</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.mobileNumber")}
                      />
                      {errors.driverDetails?.mobileNumber?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.mobileNumber?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Date of birth</CFormLabel>
                      <CFormInput
                        type="date"
                        {...register("driverDetails.dateOfBirth")}
                      />
                      {errors.driverDetails?.dateOfBirth?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.dateOfBirth?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Date of join</CFormLabel>
                      <CFormInput
                        type="date"
                        {...register("driverDetails.dateOfJoin")}
                      />
                      {errors.driverDetails?.dateOfJoin?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.dateOfJoin?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Nationality</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.nationality")}
                      />
                      {errors.driverDetails?.nationality?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.nationality?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Region</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.region")}
                      />
                      {errors.driverDetails?.region?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.region?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Driver Type</CFormLabel>
                      <Controller
                        name="driverDetails.driverType"
                        control={control}
                        render={({ field }) => (
                          <ReactSelect
                            options={driverTypeOptions}
                            isClearable={true}
                            placeholder="select driver type"
                            {...field}
                          />
                        )}
                      />
                      {errors.driverDetails?.driverType?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.driverType?.message}
                        </p>
                      )}
                    </CCol>
                  </CRow>
                  <CRow></CRow>
                </div>
                <div className="w-100 mb-3">
                  <h4>License Details</h4>
                  <hr />
                  <CRow xs={{ cols: 1, gutter: 4 }} md={{ cols: 4, gutter: 4 }}>
                    <CCol>
                      <CFormLabel>License no.</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.licenseNumber")}
                      />
                      {errors.driverDetails?.licenseNumber?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.licenseNumber?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>License City</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.licenseCity")}
                      />
                      {errors.driverDetails?.licenseCity?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.licenseCity?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>License issue date</CFormLabel>
                      <CFormInput
                        type="date"
                        max={moment().format("YYYY-MM-DD")}
                        {...register("driverDetails.licenseIssuedDate")}
                      />
                      {errors.driverDetails?.licenseIssuedDate?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.licenseIssuedDate?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>License exipry date</CFormLabel>
                      <CFormInput
                        type="date"
                        min={moment().format("YYYY-MM-DD")}
                        {...register("driverDetails.licenseExpiredDate")}
                      />
                      {errors.driverDetails?.licenseIssuedDate?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.licenseIssuedDate?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Driving lincese type</CFormLabel>
                      <Controller
                        name="driverDetails.drivingLicenseType"
                        control={control}
                        render={({ field }) => (
                          <ReactSelect
                            options={drivingLicenseTypeOptions}
                            placeholder="Type of license"
                            isClearable={true}
                            {...field}
                          />
                        )}
                      />
                      {errors.driverDetails?.drivingLicenseType?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.drivingLicenseType?.message}
                        </p>
                      )}
                    </CCol>
                  </CRow>
                </div>

                <div className="w-100 mb-3">
                  <h4>Passport Details</h4>
                  <hr />
                  <CRow xs={{ cols: 1, gutter: 4 }} md={{ cols: 4, gutter: 4 }}>
                    <CCol>
                      <CFormLabel>Passport no.</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.passportNumber")}
                      />
                      {errors.driverDetails?.passportNumber?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.passportNumber?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Passport issue date.</CFormLabel>
                      <CFormInput
                        type="date"
                        max={moment().format("YYYY-MM-DD")}
                        {...register("driverDetails.passportIssueDate")}
                      />
                      {errors.driverDetails?.passportIssueDate?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.passportIssueDate?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Passport expiry date.</CFormLabel>
                      <CFormInput
                        type="date"
                        max={moment().format("YYYY-MM-DD")}
                        {...register("driverDetails.passportExpireDate")}
                      />
                      {errors.driverDetails?.passportExpireDate?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.passportExpireDate?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Visa no.</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.visaNumber")}
                      />
                      {errors.driverDetails?.visaNumber?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.visaNumber?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Location of visa issuance</CFormLabel>
                      <CFormInput
                        type="text"
                        {...register("driverDetails.visaCity")}
                        placeholder="issuance city name"
                      />
                      {errors.driverDetails?.visaCity?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.visaCity?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Visa issue date.</CFormLabel>
                      <CFormInput
                        type="date"
                        max={moment().format("YYYY-MM-DD")}
                        {...register("driverDetails.visaIssueDate")}
                      />
                      {errors.driverDetails?.visaIssueDate?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.visaIssueDate?.message}
                        </p>
                      )}
                    </CCol>
                    <CCol>
                      <CFormLabel>Visa expire date.</CFormLabel>
                      <CFormInput
                        type="date"
                        min={moment().format("YYYY-MM-DD")}
                        {...register("driverDetails.visaExpiredDate")}
                      />
                      {errors.driverDetails?.visaExpiredDate?.message && (
                        <p className="error_text">
                          {errors.driverDetails?.visaExpiredDate?.message}
                        </p>
                      )}
                    </CCol>
                  </CRow>
                </div>
              </>
            )} */}

            <div className="d-flex justify-content-end mt-3">
              <CButton type="submit" color="primary" className="px-5 py-2 me-3">
                Submit
              </CButton>
            </div>
          </CRow>
        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default CreateUserForm;
